import React, { useState, useEffect } from "react";
import { Multiselect } from "multiselect-react-dropdown";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { RingLoader } from "react-spinners";
import Cookies from "universal-cookie";
import * as ProviderService from "../../services/ProviderService";
import { IMAGE } from "../../Constants/Image";
import swal from "sweetalert";
import { t } from "../../../translations";

function LoginSection({ setForgetSection, setLoginSection, setChangeSection }) {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailAlert, setEmailAlert] = useState("");
  const [passwordAlert, setPasswordAlert] = useState("");
  const [password, setPassword] = useState("");
  const [society, setSociety] = useState(null);
  const [societyAlert, setSocietyAlert] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [filtro_soc] = useState([
    { type: "(1010) Colombina S.A", id: "1010" },
    { type: "(1020) Colombina del Cauca S.A", id: "1020" },
    { type: "(1030) Distrib. Colombina Ltda", id: "1030" },
    { type: "(1040) Prod. Andina DULCES S.A", id: "1040" },
    { type: "(1050) CONSERVAS COLOMBNA S.A", id: "1050" },
    { type: "(1130) Chicles Colombina S.A", id: "1130" },
    { type: "(1140) Prod. Lácteos Robin Hood", id: "1140" },
    { type: "(1150) Ind. Nal Alimentos Lácteos", id: "1150" },
    { type: "(1170) COMEXA DE COLOMBINA S.A", id: "1170" },
    { type: "(1175) COLOMBINA ENERGIA S.A.S", id: "1175" },
    { type: "(1180) FUERZA LOGISTICA DE DISTR", id: "1180" },
    { type: "(1185) RALL-E SAS", id: "1185" },
    { type: "(1210) Fundación Colombina", id: "1210" },
    { type: "(3020) Procalidad S.A.Costa Rica", id: "3020" },
    { type: "(3030) Procalidad de El Salvador", id: "3030" },
    { type: "(3050) CAPSA S.A", id: "3050" },
    { type: "(3060) Negocios CentroAme S.A HN", id: "3060" },
    { type: "(3070) Negocios CentroAme S.A PA", id: "3070" },
    { type: "(3120) Colombina de Republica Dominicana", id: "3120" },
    { type: "(4050) Colombina Candy Inc", id: "4050" },
    { type: "(7010) FIESTA COLOMBINA S.L.U.", id: "7010" },
    { type: "(7020) Comercializadora Arlequin", id: "7020" },
    { type: "(7030) Pierrot España SL", id: "7030" },
    { type: "(7031) Pierrot De España S.L", id: "7031" },
    { type: "(7050) Colombina Fiesta FZE", id: "7050" },
  ]);

  const cookies = new Cookies();

  const handlerClick = async (e) => {
    /**
     * React - Preventing Form Submission
     * In javascript you can prevent that by using an event handler and
     * calling e.preventDefault() on button click, or form submit. e is
     * the event object passed into the event handler.
     */
    e.preventDefault();
    if (!validations()) {
      return;
    }
    setShowLoader(true);

    let data = {
      Usuario: email,
      Clave: password,
      Sociedad: society,
    };
    ProviderService.validaAcceso(data)
      .then((response) => {
        if (response.data.name === "Error") {
          if (response.data.message === "Request failed with status code 500") {
            swal({
              title: "Error",
              text: t("login.serviceUnderMaintenance"),
              icon: "warning",
            });
          } else {
            swal({
              title: "Error",
              text: t("login.errorLogging"),
              icon: "warning",
            });
          }
          setShowLoader(false);
        } else {
          var data = response.data["n0:PortalProveedoresDataResponse"];
          if (data) {
            if (data.validaAcceso) {
              if (data.validaAcceso.E_CSAP && !data.validaAcceso.E_MENS) {
                cookies.set("user_portal", email, { path: "/" });
                cookies.set("society", society, { path: "/" });
                cookies.set("e_csap", data.validaAcceso.E_CSAP, {
                  path: "/",
                });
                setShowLoader(false);
                navigate("/Inicio");
              } else {
                swal({
                  title: t("login.errorLogging"),
                  text: data.validaAcceso.E_MENS,
                  icon: "error",
                  button: t("login.accept"),
                });
                setShowLoader(false);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (email !== "") {
      validationEmail();
    }
  }, [email]);

  useEffect(() => {
    if (password !== "") {
      validationPassword();
    }
  }, [password]);

  useEffect(() => {
    if (society !== null) {
      validationSociety();
    }
  }, [society]);

  /**
   * Global Validations
   */
  const validations = () => {
    if (password && password.length < 6 && !email) {
      setEmailAlert(t("validation.requiredUsername"));
      setPasswordAlert(t("validation.minimumPassword"));
      return false;
    } else if (!email && !password && !society) {
      setEmailAlert(t("validation.requiredUsername"));
      setPasswordAlert(t("validation.requiredCurrentPassword"));
      setSocietyAlert(t("validation.requiredCompany"));
      return false;
    } else if (!email && !password) {
      setEmailAlert(t("validation.requiredUsername"));
      setPasswordAlert(t("validation.requiredCurrentPassword"));
      return false;
    } else if (!email) {
      setEmailAlert(t("validation.requiredUsername"));
      return false;
    } else if (!password) {
      setPasswordAlert(t("validation.requiredCurrentPassword"));
      return false;
    } else if (password.length < 6) {
      setPasswordAlert(t("validation.minimumPassword"));
      return false;
    } else if (!society) {
      setSocietyAlert(t("validation.requiredCompany"));
      return false;
    }
    return true;
  };

  /**
   * Email Validations
   */
  const validationEmail = () => {
    if (!email) {
      setEmailAlert(t("validation.requiredUsername"));
      return;
    } else {
      setEmailAlert("");
      return;
    }
  };

  /**
   * Society Validations
   */
  const validationSociety = () => {
    if (!society) {
      setSocietyAlert(t("validation.requiredCompany"));
      return false;
    } else {
      setSocietyAlert("");
      return true;
    }
  };

  /**
   * Password Validations
   */
  const validationPassword = () => {
    if (!password) {
      setPasswordAlert(t("validation.requiredCurrentPassword"));
      return;
    } else if (password.length < 6) {
      setPasswordAlert(t("login_init.minimumPassword"));
      return;
    } else {
      setPasswordAlert("");
      return;
    }
  };

  function onSelectType(selectedList, selectedItem) {
    const type = selectedList.map((item) => item);
    setSociety(type[0].id);
  }

  return (
    <div>
      <div className="flex flex-col justify-center md:justify-start my-auto pt-4 md:pt-0 px-4 md:px-24 lg:px-32 mb-10">
        <img
          src={IMAGE.COLOMBINA_IMAGE}
          alt="imagen producto"
          className="w-1/3"
        />
        <p className="text-center text-3xl font-Flama-Regular font-bold mt-4">
          {t("login_init.welcome")}
        </p>
        <form className="flex flex-col p-2" onSubmit={handlerClick}>
          <div className="flex flex-col pt-4">
            <label htmlFor="email" className="text-lg font-Flama-Regular">
              {t("login_init.username")}
            </label>
            <input
              id="email"
              placeholder={t("login_init.username")}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline"
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              value={email}
            />
            {emailAlert !== "" && (
              <div
                className="bg-red-100 border-l-4 border-red-500 text-red-700 p-2 mt-2"
                role="alert"
              >
                <p className="font-bold">Error:</p>
                <p>{emailAlert}</p>
              </div>
            )}
          </div>

          <div className="flex flex-col pt-4">
            <label htmlFor="password" className="text-lg font-Flama-Regular">
              {t("login_init.password")}
            </label>
            <div className="flex flex-row">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder={t("login_init.password")}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                value={password}
              />
              <div
                className="rounded-full h-10 w-10 flex items-center justify-center"
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <VisibilityIcon></VisibilityIcon>
                ) : (
                  <VisibilityOffIcon></VisibilityOffIcon>
                )}
              </div>
            </div>
            {passwordAlert !== "" && (
              <div
                className="bg-red-100 border-l-4 border-red-500 text-red-700 p-2 mt-2"
                role="alert"
              >
                <p className="font-bold">Error:</p>
                <p>{passwordAlert}</p>
              </div>
            )}
          </div>
          <div className="flex flex-col pt-4">
            <label htmlFor="society" className="text-lg font-Flama-Regular">
              {t("login_init.society")}
            </label>
            <Multiselect
              options={filtro_soc}
              singleSelect={true}
              displayValue="type"
              placeholder={t("login_init.societies")}
              emptyRecordMsg={t("login_init.noSocietiesFound")}
              avoidHighlightFirstOption={true}
              onSelect={onSelectType}
              id={3}
            />
            {societyAlert !== "" && (
              <div
                className="bg-red-100 border-l-4 border-red-500 text-red-700 p-2 mt-2"
                role="alert"
              >
                <p className="font-bold">Error:</p>
                <p>{societyAlert}</p>
              </div>
            )}
          </div>
          <button
            className="bg-black text-white font-bold text-lg hover:bg-gray-700 p-2 mt-8 font-Flama-Regular"
            type="submit"
          >
            {t("login_init.login")}
          </button>
        </form>
        {showLoader ? (
          <div className="flex items-center justify-center flex-col mt-6">
            <RingLoader color="blue" size={50} />
          </div>
        ) : null}
        <div className="flex flex-col items-center p-2">
          <div className="text-center mt-1">
            <a
              href="https://portal-proveedores-col.s3.amazonaws.com/Instructivo.pdf"
              target="_blank"
            >
              <label className="mb-20 text-blue-500 cursor-pointer text-sm">
                {t("login_init.viewinstructions")}
              </label>
            </a>
          </div>
          <div className="text-center mt-1">
            <a
              href="https://portal-proveedores-col.s3.amazonaws.com/Detallado_proveedores.pdf"
              target="_blank"
            >
              <label className="mb-20 text-blue-500 cursor-pointer text-sm">
                {t("login_init.viewdetailedsupplierinstructions")}
              </label>
            </a>
          </div>
          <div className="text-center mt-1">
            <a
              href="https://portal-proveedores-col.s3.amazonaws.com/Detallado_inversionistas.pdf"
              target="_blank"
            >
              <label className="mb-20 text-blue-500 cursor-pointer text-sm">
                {t("login_init.viewdetailedinvestorguide")}
              </label>
            </a>
          </div>
          <div className="text-center pt-1 pb-12">
            <button
              className="bg-blue-400  font-bold text-lg hover:bg-blue-600 p-2 mt-8 font-Flama-Regular mx-1"
              onClick={() => {
                setForgetSection(true);
                setLoginSection(false);
              }}
            >
              {t("login_init.rememberPassword")}
            </button>
            <button
              className="bg-blue-400  font-bold text-lg hover:bg-blue-600 p-2 mt-8 font-Flama-Regular mx-1"
              onClick={() => {
                setLoginSection(false);
                setChangeSection(true);
              }}
            >
              {t("login_init.changePassword")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginSection;
